import { LogLevel, sendFelogEvent } from '@lib/tracking/felog/event'
import { gnarClient } from '@lib/tracking/gnar'
import { transformToObject } from '@lib/utils/error'

export enum LogErrorMetrics {
  TouchDeviceDetectionFailed = 'TouchDeviceDetectionFailed',
  ContentRendererError = 'ContentRendererError',
  GTMDataLayerPushError = 'GTMDataLayerPushError',
  GnarContainerIdFailed = 'GnarContainerIdFailed',
  BoundaryError = 'BoundaryError',
  IframeError = 'IframeError',
}

export async function logError(
  msg: string,
  metricName: LogErrorMetrics,
  extraInfo: { [key: string]: string | object } = {},
  logger = 'Error',
): Promise<void> {
  const extra: { [key: string]: string | object | LogErrorMetrics } = {
    metricName,
    ...extraInfo,
  }
  try {
    extra.containerId = await gnarClient.getContainerId()
  } catch (error) {
    console.log(error)
    try {
      await sendFelogEvent('Cannot get containerID', LogLevel.Error, logger, {
        metricName: 'cannotGetContainerID',
        error: transformToObject(error as Error),
        ...extraInfo,
      })
    } catch (error) {
      console.log(error)
      // Ignore this error. Something went wrong with felog event logging
    }
  }

  try {
    await sendFelogEvent(msg, LogLevel.Error, logger, extra)
  } catch (error) {
    console.log(error)
    // Ignore this error. Something went wrong with felog event logging
  }
}
